module.exports = __webpack_public_path__ + "static/img/4.be80686.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/4.png
// module id = +MNR
// module chunks = 0